import WorkOrderBadge from './WorkOrderBadge'

export default WorkOrderBadge
